import {Injectable} from "@angular/core";
import {CompoApp} from "./CompoApp";
import { HttpClient } from "@angular/common/http";
import {UrlBuilder} from "../models/frontend_entities/UrlBuilder";
import Constants from "../Constants";
import {UserAreaDTO} from "../models/rights/user-area/UserAreaDTO";
import {take} from "rxjs/operators";
import {Observable} from "rxjs/internal/Observable";
import {firstValueFrom} from "rxjs";
import {ComponentClassWithChildrenCountDto} from "../models/component_class/ComponentClassWithChildrenCountDto";

@Injectable()
export class UserAreaService {

  //region CONSTRUCTOR
  constructor(public app: CompoApp, public http: HttpClient) {}
  //endregion

  //region GET
  getById(id: string): Observable<UserAreaDTO> {
    const url = new UrlBuilder(Constants.URLS.userArea.getById)
      .param("id", id)
      .param("lang", this.app.data.getLang())
      .build();

    return this.http.get<UserAreaDTO>(url);
  }

  getByIds(ids: string[]): Promise<UserAreaDTO[]> {
    const url = new UrlBuilder(Constants.URLS.userArea.getByIds)
      .param("ids", ids)
      .param("lang", this.app.data.getLang())
      .build();

    return firstValueFrom(this.http.get<UserAreaDTO[]>(url));
  }
  //endregion

  //region SAVE
  save(dto: UserAreaDTO) {
    const url = new UrlBuilder(Constants.URLS.userArea.base)
      .param("accessMode", this.app.data.getAccessMode())
      .param("lang", this.app.data.getLang())
      .build();
    return firstValueFrom(this.http.post<UserAreaDTO>(url, dto));
  }
  //endregion

  //region UPDATE
  update(dto: UserAreaDTO): Observable<UserAreaDTO> {
    const url = new UrlBuilder(Constants.URLS.userArea.base)
      .param("accessMode", this.app.data.getAccessMode())
      .param("lang", this.app.data.getLang())
      .build();
    return this.http.put<UserAreaDTO>(url, dto).pipe(take(1));
  }
  //endregion

  //region DELETE
  delete(userAreaId: string): Observable<string> {
    const url = new UrlBuilder(Constants.URLS.userArea.base)
      .param("id", userAreaId)
      .build();
    return this.http.delete<string>(url).pipe(take(1));
  }
  //endregion

  // region ADD
  addSelection(
    userAreaId: string,
    organizationIds: Set<string>,
    classIds: Set<string>,
    locationIds: Set<string>,
    objectIds: Set<string>,
    moduleIds: Set<string>
  ): Observable<UserAreaDTO> {
    const url = new UrlBuilder(Constants.URLS.userArea.activeAddSelection + '/' + userAreaId)
      .param("accessMode", this.app.data.getAccessMode())
      .param("lang", this.app.data.getLang())
      .build();

    return this.http.post<UserAreaDTO>(url, {
      organizationIds: [...organizationIds],
      locationIds: [...locationIds],
      classIds: [...classIds],
      objectIds: [...objectIds],
      moduleIds: [...moduleIds]
    });
  }
  //endregion

  //region REMOVE
  removeSelection(
    userAreaId: string,
    organizationIds: Set<string>,
    classIds: Set<string>,
    locationIds: Set<string>,
    objectIds: Set<string>,
    moduleIds: Set<string>
  ): Observable<UserAreaDTO> {
    const url = new UrlBuilder(Constants.URLS.userArea.activeRemoveSelection + '/' + userAreaId)
      .param("accessMode", this.app.data.getAccessMode())
      .param("lang", this.app.data.getLang())
      .build();

    return this.http.put<UserAreaDTO>(url, {
      organizationIds: [...organizationIds],
      locationIds: [...locationIds],
      classIds: [...classIds],
      objectIds: [...objectIds],
      moduleIds: [...moduleIds]
    });
  }
  //endregion
}
